import NumberToPersianWord from "number_to_persian_word";


// حرف اول کل رشته را بزرگ می‌کند و بقیه حروف را کوچک
// مثال:
// "MADISON" -> "Madison"
function Capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

// اگر ورودی رشته نباشد، مقدار خالی برمی‌گرداند
// سپس متن را با regex به کلمات تقسیم می‌کند
// هر کلمه‌ای که با حرف انگلیسی شروع شود را Capitalize می‌کند
function CapitalizeAllWords(string = "") {
    if (typeof string !== 'string') {
        return ""; 
    }

    let splitStr = string.split(/(\b|\s+)/);
    for (let i = 0; i < splitStr.length; i++) {
        if (/^[a-zA-Z]/.test(splitStr[i])) {
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].slice(1).toLowerCase();
        }
    }
    return splitStr.join(' ');
}

// کل رشته را به حروف بزرگ تبدیل می‌کند
// مثال: "hello" -> "HELLO"
function Uppercase(string = "") {
    return string.toUpperCase();
}
// کل رشته را به حروف کوچک تبدیل می‌کند
// مثال: "HELLO" -> "hello"
function Lowercase(string = "") {
    return string.toLowerCase();
}
// اعداد انگلیسی را به اعداد فارسی تبدیل می‌کند
// فقط اگر زبان صفحه فارسی باشد
function NumToFa(string = "", pageLanguage = "fa") {
    return pageLanguage === "fa" ? NumberToPersianWord.convertEnToPe(string) : string;
}

// بررسی می‌کند آیا متن شامل حروف فارسی/عربی است
function containsPersianChars(text = "") {
    return /[\u0600-\u06FF]/.test(text);
}

// اعداد را فقط وقتی به فارسی تبدیل می‌کند که زبان صفحه fa باشد و خود متن فارسی باشد
function formatAddressDigits(text = "", pageLanguage = "fa") {
    if (!text) return text;
    if (pageLanguage === "fa" && containsPersianChars(text)) {
        return NumberToPersianWord.convertEnToPe(String(text));
    }
    return text;
}
// ابتدا ترتیب اعداد را برعکس می‌کند
// سپس اگر زبان فارسی باشد، اعداد را فارسی می‌کند
function RangeToFa(string = "", pageLanguage = "fa") {
    let temp = string.split(' - ').reverse().join(' - ');
    return pageLanguage === "fa" ? NumberToPersianWord.convertEnToPe(temp) : string;
}
// برای نرمال‌سازی متن فارسی
// حروف عربی مثل "ي" و "ك" را به معادل فارسی "ی" و "ک" تبدیل می‌کند
// سپس اگر زبان فارسی باشد اعداد را هم فارسی می‌کند
function convertToPersian(string_farsi = "", pageLanguage = "fa") {
    if (string_farsi !== null && string_farsi !== undefined && string_farsi !== "") {
        let tempString = string_farsi.replace("ي", "ی");
        tempString = tempString.replace("ي", "ی");
        tempString = tempString.replace("ي", "ی");
        tempString = tempString.replace("ي", "ی");
        tempString = tempString.replace("ي", "ی");
        tempString = tempString.replace("ي", "ی");
        tempString = tempString.replace("ي", "ی");
        tempString = tempString.replace("ي", "ی");
        tempString = tempString.replace("ي", "ی");
        tempString = tempString.replace("ي", "ی");
        tempString = tempString.replace("ي", "ی");
        tempString = tempString.replace("ي", "ی");
        tempString = tempString.replace("ي", "ی");
        tempString = tempString.replace('ك', 'ک');
        return NumToFa(tempString, pageLanguage);
    } else
        return string_farsi;
}
// اگر متن انگلیسی باشد، اول هر کلمه را بزرگ می‌کند
// اگر متن فارسی یا ترکیبی باشد، بدون تغییر برمی‌گرداند
// مثال:
// "MADISON / off white" -> "Madison / Off White"
function capitalizeIfEnglish(text = "") {
  if (!text) return text;

  // تابع کمکی برای بزرگ کردن اول هر کلمه انگلیسی
  function capitalizeEnglishWords(t) {
      return t.replace(/\b[a-zA-Z]+\b/g, (word) =>
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      );
  }

  // تشخیص اینکه رشته فقط شامل حروف انگلیسی و علائم رایج باشد
  const isMostlyEnglish = /^[a-zA-Z0-9\s&\-\/&]+$/.test(text);

  if (isMostlyEnglish) {
      return capitalizeEnglishWords(text);
  }

  return text;
}

// حرف اول هر کلمه را بزرگ می‌کند
// ولی بقیه حروف را تغییر نمی‌دهد
// مثال:
// "hello WORLD" -> "Hello WORLD"
function capitalizeFirstLetters(label) {
    return label
        ?.split(' ') 
        .map(word => word.charAt(0).toUpperCase() + word.slice(1)) 
        .join(' '); 
}
// پارامترهای query در URL را مرتب می‌کند
// مثال:
// ?b=2&a=1 -> ?a=1&b=2
function sortSearchFilter(searchFilter) {
    const query = searchFilter.startsWith("?") ? searchFilter.slice(1) : searchFilter;
    const params = query.split("&");
    const parsedParams = params.map(param => {
        const [key, value] = param.split("=");
        return { key, value };
    });

    const sortedParams = parsedParams.sort((a, b) => a.key.localeCompare(b.key));
    const sortedQuery = sortedParams.map(param => `${param.key}=${param.value}`).join("&");

    return `?${sortedQuery}`;
}
// تمام متن را ابتدا lowercase می‌کند
// سپس حرف اول هر کلمه را بزرگ می‌کند
// مثال:
// "HELLO WORLD" -> "Hello World"
function capitalizeWordsText(text) {
  if (!text || typeof text !== "string") {
    return ""; 
  }

  return text
    .toLowerCase()
    .split(" ")
    .map(word => 
      word ? word.charAt(0).toUpperCase() + word.slice(1) : ""
    )
    .join(" ");
}
  // بدون پسوند: اگر طول بیشتر از maxBaseLength بود، برش بزن
const truncateFileName = (fileName, maxBaseLength = 14) => {
  const lastDot = fileName.lastIndexOf('.');
  if (lastDot === -1) {
  
    return fileName.length > maxBaseLength 
      ? fileName.substring(0, maxBaseLength - 3) + '...' 
      : fileName;
  }
  
  const ext = fileName.substring(lastDot); 
  const base = fileName.substring(0, lastDot);
  
  if (base.length <= maxBaseLength) {
    return fileName;
  }

  const truncatedBase = base.substring(0, maxBaseLength - 3) + '...';
  return truncatedBase + ext;
}; 

  // اعداد داخل رشته را با جداکننده هزارگان فرمت می‌کند
// مثال:
// "price 10000" -> "price 10,000"

function formatPrice(price) {
    if (/\d/.test(price)) {
      return price.replace(/\d+/g, (match) => {
        return parseInt(match, 10).toLocaleString();
      });
    }
  
    return price;
  }

  const toPersianDigits = (numStr) => {
    const persianDigits = '۰۱۲۳۴۵۶۷۸۹';
    return numStr.replace(/\d/g, (d) => persianDigits[parseInt(d)]);
  };
  
  // جداسازی عدد و واحد از رشته مثل "150.67 KB"
  const splitFileSize = (sizeStr) => {
    if (!sizeStr || typeof sizeStr !== 'string') return null;
    const match = sizeStr.match(/^(\d+(?:\.\d+)?)\s*([A-Za-z]+)$/);
    if (match) {
      return { number: match[1], unit: match[2] };
    }
    return null;
  };
  
  // کامپوننت برای نمایش حجم فایل به فارسی
  const FormattedFileSize = ({ sizeString }) => {
    const parts = splitFileSize(sizeString);
    if (!parts) return <span>{sizeString}</span>;
    const persianNumber = toPersianDigits(parts.number);
    return (
      <>
      <span>{parts.unit}</span>
        <span>{persianNumber}</span> 
      </>
    );
  };

  let pageNameDefault = [
    { id: 1, name: "HardWare", page_default: "NecessaryOrdering", name_fa: "ملزومات" },
    { id: 2, name: "BedAndBath", page_default: "ReadyMadeProduct", name_fa: " خواب و حمام" },
    {
      id: 3,
      name: "Fabric By Meter",
      page_default: "ReadyMadeFabricItem",
      name_fa: "پارچه های متری",
    },
    { id: 4, name: "Towels", page_default: "ReadyMadeTowel", name_fa: "حوله ها" },
    {
      id: 5,
      name: "Collection Ready Made Shades",
      page_default: "ReadyMadeShadeItem",
      name_fa: "مجموعه شیدهای آماده",
    },
    {
      id: 6,
      name: "Ready Made Shades",
      page_default: "ReadyMadeDraperyItem",
      name_fa: "شیدهای آماده",
    },
    { id: 7, name: "Ready Made Drapery", page_default: "OneCurtain", name_fa: "پرده آماده" },
  ];

export {Capitalize, CapitalizeAllWords, Uppercase, Lowercase, NumToFa, containsPersianChars, formatAddressDigits, convertToPersian , capitalizeIfEnglish ,RangeToFa , capitalizeFirstLetters  , sortSearchFilter , truncateFileName , formatPrice ,FormattedFileSize , capitalizeWordsText , pageNameDefault};